const parseColor = require('parse-color'); // Parses CSS color like a boss
import $ from "jquery"
import { Circle, Rect, Vector2 } from "peet-math";
import { PlanSeat } from "./plan-seat";


// This returns a simple invisible DIV with the provided class name
export function getStylingDummy(className?: string) {
    return $(`<div class='${className ? className : ""}' style='display:none;'></div>`);
}

// Once you added your dummy where it should go, call this to retrieve the css info from your dummy object
// INFO : Add all the thing you need in there. What's here is what we needed so far.
export function cssDummyToStyle(cssDummy: JQuery<HTMLElement>): CSSDummyStyle {
    const style: CSSDummyStyle = {
        color: getColorOrDefault(cssDummy.css('color'), 'white'),
        backgroundColor: getColorOrDefault(cssDummy.css('background-color'), 'black'),
        borderColor: null,
        colorObj: null,
        backgroundColorObj: null,
        borderColorObj: null
    };

    style.borderColor = getColorOrDefault(cssDummy.css('border-top-color'), style.backgroundColor),

        // Parse things
        style.colorObj = parseColor(style.color);
    style.backgroundColorObj = parseColor(style.backgroundColor);
    style.borderColorObj = parseColor(style.borderColor);

    return style;
};

export type CSSDummyStyle = {
    color: string,
    backgroundColor: string,
    borderColor: string,
    colorObj: any,
    backgroundColorObj: any,
    borderColorObj: any
};

export function getColorOrDefault(color: string, defaultColor: string) {
    if ((color === '') || (color === 'transparent')) {
        return defaultColor;
    } else {
        return color;
    }
};

export function getOffset(element: HTMLElement) {
    const rect = element.getBoundingClientRect();
    const scrollTop = (document.documentElement.scrollTop != null) ? document.documentElement.scrollTop : document.body.scrollTop;
    const scrollLeft = (document.documentElement.scrollLeft != null) ? document.documentElement.scrollLeft : document.body.scrollLeft;
    return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
    };
};

export function isPointInsideCircle(circle: Circle, point: Vector2) {
    return circle.center.distanceFrom(point) <= circle.radius;
}

export function isPointInsideRect(r: Rect, p: Vector2): boolean {
    return p.x >= r.x && p.x <= r.x + r.width 
        && p.y >= r.y && p.y <= r.y + r.height;
}

export function getSeatBoudingBox(seat: PlanSeat): Rect {
    return new Rect(seat.x, seat.y, seat.size, seat.size)
}